/** 平台看板返回结构归一化：统一成 metrics / works / fans_overview / visitor_portrait */

/** 小红书官方口径只有 7/30 两个窗口快照 */
function pickWindow(bag, days) {
  if (!bag || typeof bag !== 'object') return {}
  const key = Number(days) >= 30 ? 'thirty' : 'seven'
  const hit = bag[key] || bag.seven || bag.thirty
  return hit && typeof hit === 'object' ? hit : {}
}

function toRows(list) {
  return (Array.isArray(list) ? list : []).map((row) => ({
    name: row?.name ?? row?.label ?? row?.key ?? '—',
    percent: Number(row?.percent ?? row?.value ?? 0),
  }))
}

function toList(bag) {
  if (Array.isArray(bag)) return bag
  return Array.isArray(bag?.items) ? bag.items : []
}

/** 小红书 type：1 图文 / 2 视频 */
const XHS_NOTE_TYPE = { 1: '图文', 2: '视频' }

function withNoteType(list) {
  return list.map((n) => (n?.note_type ? n : { ...n, note_type: XHS_NOTE_TYPE[n?.type] || '—' }))
}

export function normalizeXhsAccountBoard(raw, { days } = {}) {
  const data = raw || {}
  const win = pickWindow(data.fans_overview, days)
  const fans = data.fans || {}
  const out = {
    ...data,
    metrics: data.metrics || data.period?.metrics || {},
    works: withNoteType(toList(data.works).length ? toList(data.works) : toList(data.notes)),
    fans_overview: {
      followers: win.fans_count ?? fans.fans_count ?? data.account?.followers,
      new_fans: win.rise_fans_count,
      lost_fans: win.leave_fans_count,
    },
    visitor_portrait: {
      source: toRows(pickWindow(data.view_source, days).items),
      gender: toRows(fans.gender),
      age: toRows(fans.age),
      location: toRows(fans.city?.length ? fans.city : fans.province),
    },
    stats_error: data.notes?.error || data.live_error || '',
  }
  delete out.notes
  return out
}

export function normalizeXhsGroupBoard(raw, { days } = {}) {
  const data = raw || {}
  const win = pickWindow(data.fans_overview, days)
  const out = {
    ...data,
    metrics: data.metrics || data.period?.metrics || {},
    works: withNoteType(toList(data.works).length ? toList(data.works) : toList(data.notes)),
    fans_overview: {
      fans_count: win.fans_count,
      followers: win.fans_count,
      rise_fans_count: win.rise_fans_count,
    },
    ok_count: data.ok_count ?? data.group?.ok_count,
    total_count: data.total_count ?? data.group?.member_total,
  }
  delete out.notes
  return out
}

export function normalizeXhsNote(raw) {
  const data = raw || {}
  return {
    ...data,
    metrics: data.metrics || data.core || {},
  }
}
